import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";
import HomePage2 from "../HomePage2/HomePage2";
import HomePage3 from "../HomePage3/HomePage3";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import WebsiteDesignPage from "../WebsiteDesignPage/WebsiteDesignPage";
import MobileAppDevelopmentPage from "../MobileAppDevelopmentPage/MobileAppDevelopmentPage";
import ECommerceDevelopmentPage from "../ECommerceDevelopmentPage/ECommerceDevelopmentPage";
import WebDevelopmentPage from "../WebDevelopmentPage/WebDevelopmentPage";
import SoftwareTestingPage from "../SoftwareTestingPage/SoftwareTestingPage";
import WebsiteRedesigningPage from "../WebsiteRedesigningPage/WebsiteRedesigningPage";
import ChatBotPage from "../ChatBotPage/ChatBotPage";
import UiUxDesignPage from "../UiUxDesignPage/UiUxDesignPage";
import SchoolManagementPage from "../SchoolManagementPage/SchoolManagementPage";
import HospitalManagementPage from "../HospitalManagementPage/HospitalManagementPage";
import FoodDeliveryPage from "../FoodDeliveryPage/FoodDeliveryPage";
import UniversityErpPage from "../UniversityErpPage/UniversityErpPage";
import OnlineExamPage from "../OnlineExamPage/OnlineExamPage";
import ECommerceAppPage from "../ECommerceAppPage/ECommerceAppPage";
import GroceryDeliveryPage from "../GroceryDeliveryPage/GroceryDeliveryPage";
import HrmPage from "../HrmPage/HrmPage";
import TaxiBookingPage from "../TaxiBookingPage/TaxiBookingPage";
import WebsiteMaintenancePage from "../WebsiteMaintenancePage/WebsiteMaintenancePage";
import DigitalMarketingPage from "../DigitalMarketingPage/DigitalMarketingPage";
import DataAnalyticsPage from "../DataAnalyticsPage/DataAnalyticsPage";
import CareerSection from "../CareerSection/CareerSection";
import CareerDetails from "../CareerDetails/CareerDetails";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import TeamPage from "../TeamPage/TeamPage";
import ScrollToTop from "./ScrollToTop";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";

// ✅ Router Component
const AllRoute: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={<Homepage />} />
          <Route path="/home" element={<Homepage />} />
          <Route path="/ai-marketing" element={<HomePage2 />} />
          <Route path="/ai-chatbot" element={<HomePage3 />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route path="/service-details" element={<SeviceSinglePage />} />
          <Route path="/website-design" element={<WebsiteDesignPage />} />
          <Route
            path="/mobile-app-development"
            element={<MobileAppDevelopmentPage />}
          />
          <Route
            path="/e-commerce-development"
            element={<ECommerceDevelopmentPage />}
          />
          <Route path="/web-development" element={<WebDevelopmentPage />} />
          <Route path="/software-testing" element={<SoftwareTestingPage />} />
          <Route path="/website-redesigning" element={<WebsiteRedesigningPage />} />
          <Route path="/ui-ux-design" element={<UiUxDesignPage />} />
          <Route path="/school-management-system" element={<SchoolManagementPage />} />
          <Route path="/hospital-management-system" element={<HospitalManagementPage />} />
          <Route path="/food-delivery-website-app" element={<FoodDeliveryPage />} />
          <Route path="/grocery-delivery-app" element={<GroceryDeliveryPage />} />
          <Route path="/hrm" element={<HrmPage />} />
          <Route path="/taxi-booking-app" element={<TaxiBookingPage />} />
          <Route path="/university-institution-college-erp" element={<UniversityErpPage />} />
          <Route path="/online-exam-software" element={<OnlineExamPage />} />
          <Route path="/e-commerce-app" element={<ECommerceAppPage />} />
          <Route path="/chat-bot" element={<ChatBotPage />} />
          <Route
            path="/website-maintenance"
            element={<WebsiteMaintenancePage />}
          />
          <Route path="/digital-marketing" element={<DigitalMarketingPage />} />
          <Route path="/data-analytics" element={<DataAnalyticsPage />} />
          <Route path="/career" element={<CareerSection />} />
          <Route path="/career-details" element={<CareerDetails />} />
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/project-details" element={<ProjectDetails />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-details" element={<BlogDetails />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
